const _excluded = ["className", "color", "SvgElement", "height", "width", "title"],
      _excluded2 = ["style"],
      _excluded3 = ["style"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import classNames from 'clsx';
import { AlignTarget } from "../Align";
import Box from "../Box";
import extractDimensions from "./extractDimensions";
import getColorClassnames from "../Icon/getColorClassnames";

class SVG extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  componentDidCatch() {
    this.setState({
      hasError: true
    });
  }

  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/React.createElement("span", null);
    }

    const _this$props = this.props,
          {
      className,
      color,
      SvgElement,
      height: h = 0,
      width: w = 0,
      title
    } = _this$props,
          props = _objectWithoutProperties(_this$props, _excluded);

    const {
      height,
      width
    } = extractDimensions(SvgElement, h, w);
    const colorClasses = getColorClassnames(color);
    const classes = classNames('SVGInline', 'SVGInline--cleaned', 'SVG', className, colorClasses);
    return /*#__PURE__*/React.createElement(AlignTarget, _extends({}, props, {
      strategy: "center",
      lineHeight: height
    }), alignProps => {
      const {
        style: propStyle = {}
      } = props,
            svgProps = _objectWithoutProperties(props, _excluded2);

      const {
        style: alignStyle = {}
      } = alignProps,
            svgAlignProps = _objectWithoutProperties(alignProps, _excluded3);

      return /*#__PURE__*/React.createElement(Box, _extends({}, props, {
        style: _objectSpread(_objectSpread({}, propStyle), alignStyle),
        title: title,
        flex: true,
        className: classes
      }), /*#__PURE__*/React.createElement(SvgElement, _extends({}, svgProps, svgAlignProps, {
        className: classes.split(/\s+/).map(cl => `${cl}-svg`).join(' '),
        height: height,
        width: width
      })));
    });
  }

}

export default SVG;